module.exports = __webpack_public_path__ + "img/response-theme.f55f5e23.svg";